import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import NEWGoogleMapsLoadScript from "./components/GoogleMapsLoadScript";

import { getLatLngCenter } from "./methods/getLatLngCenter";
import { DEFAULT_GEOFENCE_HEXCODE } from "../../../../constants";
import {
    Polygon,
    GoogleMap,
    OverlayView,
    DrawingManager,
} from '@react-google-maps/api';

// Redux Actions
import {
    set_map_control,
    set_new_geofence_from_map,
} from '../../services/redux/actions/mapControl';

import "./gmaps.css";

const GoogleMapsComponentAddPolygon = (props) => {
    const dispatch = useDispatch()
    
    // Redux Stores
    // Have to put here because thisGeofence state defaults as mapControl.geofence
    const mapControl = useSelector(state => state.v2.mapControl);
    const geofenceTemplates = useSelector(state => state.v2.geofenceTemplate);

    // State
    const [mapRef, setMapRef] = useState(null);
    const [drawingManagerRef, setDrawingManagerRef] = useState(null);
    const [thisGeofence, setThisGeofence] = useState(mapControl.geofence);

    const returnLatestGeofenceTemplateColorByGTIDs = (gtidList) => {
        let latestTemplate = {};

        gtidList.forEach((currGTID) => {
            if (!latestTemplate.createdAt || geofenceTemplates.byId[currGTID].createdAt > latestTemplate.createdAt) {
                latestTemplate = geofenceTemplates.byId[currGTID];
            }
        })

        return latestTemplate.colorHexCode ? latestTemplate.colorHexCode : DEFAULT_GEOFENCE_HEXCODE;
    }

     /**
     * Deep Cloning useEffect()
     */
    const useDeepEffect = (fn, deps) => {
        const isFirst = useRef(true);
        const prevDeps = useRef(deps);
      
        useEffect(() => {
          const isSame = prevDeps.current.every((obj, index) =>
            JSON.parse(JSON.stringify(obj)) === JSON.parse(JSON.stringify(deps[index]))
          );
      
          if (isFirst.current || !isSame) {
            fn();
          }
      
          isFirst.current = false;
          prevDeps.current = deps;
        }, [fn, deps]);
    }

    useDeepEffect(() => {
        setThisGeofence(mapControl.geofence)
    }, [mapControl.geofence])
    
    const getMapCenterAndZoom = () => {
        if (mapRef) {
            return {
                center: mapRef.getCenter(),
                zoom: mapRef.getZoom()
            }
        }

        return {
            center: mapControl.location,
            zoom: mapControl.zoom
        }
    }

    const putPolygonComplete = polygon => {
        // remove previously drawn polygon
        polygon.setMap(null)
    
        const newMarker = {
            ...mapControl.geofence,
            coordinates: polygon.getPath().getArray().map(coordinate => {
                return {
                    lat: coordinate.lat(),
                    lng: coordinate.lng(),
                }
            })
        }
        dispatch(set_new_geofence_from_map(newMarker));

        // revert drawingMode to null, ie drag
        if (drawingManagerRef) {
            drawingManagerRef.setDrawingMode(null);
        }
    }

    return (
        <GoogleMap
            id = 'example-map'
            center = {getMapCenterAndZoom().center}
            zoom = {getMapCenterAndZoom().zoom}
            mapContainerStyle = {{
                height: '100vh'
            }}
            onLoad = {ref => setMapRef(ref)}
            onDragStart = {() => {
                dispatch(set_map_control(0))
            }}
            onDragEnd = {() => {
                if (mapRef) {
                    const lat = mapRef.getCenter().lat();
                    const lng = mapRef.getCenter().lng();
                    const zoom = mapRef.getZoom();

                    mapRef.setCenter({ lat, lng });
                    mapRef.setZoom(zoom);
                }
            }}
        >

            {/* Polygon */}
            {
                thisGeofence && thisGeofence.coordinates &&
                <div>
                    <Polygon
                        path = {thisGeofence.coordinates}
                        options = {{
                            // strokeColor: "#ff0000",
                            strokeColor: returnLatestGeofenceTemplateColorByGTIDs(mapControl.selectedGeofenceTemplates),
                        }}
                    />

                    {/* <InfoWindow position = {getLatLngCenter(thisGeofence.coordinates)}>
                        <div>
                            <h4>{thisGeofence.geofenceName}</h4>

                            {
                                thisGeofence.geofenceComment && (
                                    <div>{thisGeofence.geofenceComment}</div>
                                )
                            }
                        </div>
                    </InfoWindow> */}
                    
                    <OverlayView
                        options = {{ disableAutoPan: true }}
                        position = {getLatLngCenter(thisGeofence.coordinates)}
                        mapPaneName = {OverlayView.OVERLAY_MOUSE_TARGET}
                        getPixelPositionOffset = {(width, height) => ({
                            x: -(width / 2),
                            y: -height - 3,
                        })}
                    >
                        <div 
                            style = {{
                                background: 'white',

                                border: '1px solid #ccc',
                                borderRadius: '10px',

                                paddingLeft: 10,
                                paddingRight: 10,
                                paddingTop: 8,
                                paddingBottom: 1,
                            }}
                        >
                            <h4>{thisGeofence.geofenceName}</h4>
                            <div>{thisGeofence.geofenceComment}</div>
                        </div>
                    </OverlayView>
                </div>
            }

            {
                <DrawingManager
                    onLoad = {ref => setDrawingManagerRef(ref)}
                    drawingMode = {window.google.maps.drawing.OverlayType.POLYGON}
                    options = {{
                        drawingControlOptions: {
                            position: window.google.maps.ControlPosition.TOP_CENTER,
                            drawingModes: [
                                window.google.maps.drawing.OverlayType.POLYGON,
                            ],
                        },
                        polygonOptions: {
                            strokeColor: "#ff0000",
                        }
                    }}
                    onPolygonComplete = {polygon => putPolygonComplete(polygon)}
                />
            }
        </GoogleMap>
    )
}

const GoogleMapsComponentWithLoadScript = (props) => NEWGoogleMapsLoadScript(GoogleMapsComponentAddPolygon, props)


export default GoogleMapsComponentWithLoadScript